import { render, staticRenderFns } from "./ShowcasePageEdit.vue?vue&type=template&id=3218e21c&"
import script from "./ShowcasePageEdit.vue?vue&type=script&lang=ts&"
export * from "./ShowcasePageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports